import React from "react";
import { motion } from "framer-motion/dist/framer-motion";
import { SparklesIcon, GiftIcon, LightningBoltIcon } from "@heroicons/react/outline";


const comingSoon = [
    {
        icon: LightningBoltIcon,
        title: 'Nuove sfide',
        description: 'Un modo tutto nuovo di giocare e mettersi alla prova.',
    },
    {
        icon: GiftIcon,
        title: 'Nuovi premi',
        description: 'Sorprese pensate per i tifosi più attivi.',
    },
    {
        icon: SparklesIcon,
        title: 'Nuova stagione',
        description: 'Tante novità in arrivo dentro Minigoal.',
    },
];

const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    visible: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: { delay: 0.15 * i, duration: 0.5, ease: 'easeOut' },
    }),
};

// Pagina statica: non chiama il server del gioco, che è stato spento
const GameEnded = () => {
    return (
        <div className="min-h-screen bg-gray-900 overflow-x-hidden">
            <div className="mx-auto max-w-2xl px-6 py-8">

                <div className="flex justify-center">
                    <motion.img
                        src={`${process.env.PUBLIC_URL}/game/trophy.png`}
                        alt="Vota il migliore!"
                        className="w-full max-w-xs h-auto"
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1, y: [0, -8, 0] }}
                        transition={{
                            opacity: { duration: 0.6 },
                            scale: { duration: 0.6 },
                            y: { duration: 4, repeat: Infinity, ease: 'easeInOut' },
                        }}
                    />
                </div>

                <motion.div
                    className="text-center mt-6"
                    variants={fadeUp}
                    initial="hidden"
                    animate="visible"
                    custom={1}
                >
                    <span className="inline-flex items-center rounded-full bg-red-600 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-white">
                        Triplice fischio
                    </span>
                    <h3 className="mt-4 text-3xl font-bold leading-8 text-white">
                        Gioco terminato!
                    </h3>
                    <p className="mt-4 text-sm leading-6 text-gray-300">
                        "Vota il migliore!" è arrivato alla fine. Grazie a tutti per aver giocato, votato e tifato insieme a noi:
                        siete stati voi i veri protagonisti.
                    </p>
                </motion.div>

                <motion.div
                    className="mt-8 rounded-2xl bg-gray-800 p-5"
                    variants={fadeUp}
                    initial="hidden"
                    animate="visible"
                    custom={2}
                >
                    <h4 className="text-lg font-semibold text-white">Novità in arrivo</h4>
                    <p className="mt-1 text-sm text-gray-400">
                        Stiamo già preparando il prossimo calcio d'inizio.
                    </p>

                    <ul className="mt-5 space-y-4">
                        {comingSoon.map((item, index) => (
                            <motion.li
                                key={item.title}
                                className="flex items-start"
                                variants={fadeUp}
                                initial="hidden"
                                animate="visible"
                                custom={3 + index}
                            >
                                <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-gray-900">
                                    <item.icon className="h-5 w-5 text-yellow-400" aria-hidden="true" />
                                </span>
                                <div className="ml-4">
                                    <p className="text-sm font-semibold text-white">{item.title}</p>
                                    <p className="text-sm text-gray-400">{item.description}</p>
                                </div>
                            </motion.li>
                        ))}
                    </ul>
                </motion.div>

                <motion.p
                    className="mt-8 text-center text-sm font-medium text-gray-300"
                    variants={fadeUp}
                    initial="hidden"
                    animate="visible"
                    custom={6}
                >
                    Resta sintonizzato: ci rivediamo presto in campo!
                </motion.p>

            </div>
        </div>
    );
};


export default GameEnded;
